import React from "react";
import { Form, InputGroup } from "react-bootstrap";

const PriceInput = ({
  name,
  value,
  onChange,
  onBlur,
  label,
  error,
  required = false,
  disabled = false,
  hint = "",
  placeholder = null,
  type = "text",
  min = null,
}) => {
  const defaultValue = typeof value === "number" ? 0 : "";

  return (
    <Form.Group className="mb-3">
      <Form.Label>
        {label} {required && "*"}
      </Form.Label>
      <InputGroup>
        <Form.Control
          name={name}
          type={type}
          className="bg-light"
          disabled={disabled}
          placeholder={placeholder}
          min={min}
          onBlur={onBlur}
          value={value ?? defaultValue}
          onChange={onChange}
        />
        <InputGroup.Text
          className="rounded-right font-weight-bold"
          style={{ borderStartStartRadius: "0", borderEndStartRadius: "0" }}
        >
          €
        </InputGroup.Text>
      </InputGroup>
      {hint && <Form.Text className="text-muted">{hint}</Form.Text>}
      {error && <small className="text-danger">{error}</small>}
    </Form.Group>
  );
};

export default PriceInput;
